import { useState, useContext } from 'react'
import { useLocation, useNavigate } from "react-router-dom"
import { enqueueSnackbar } from 'notistack'

import { ButtonGroup, Button, Box } from '@mui/material'

import { AppContext } from '/providers/app-context'
import { unarchiveTemplate } from '/providers/templates-api'

import ArchiveDialog from './archive-dialog'
import SynchroniseDialog from './synchronise-dialog'
import NotifyAllDialog from './notify-all-dialog'
import { getSyncIndicator, hasSyncAttention } from './sync-state-utils'

const Menu = ({ template, processing, setProcessing }) => {
  const { apiSource, apiKey, refreshTemplates } = useContext(AppContext)

  const [syncOpen, setSyncOpen] = useState(false)
  const [archiveOpen, setArchiveOpen] = useState(false)
  const [notifyOpen, setNotifyOpen] = useState(false)

  const navigate = useNavigate()
  const location = useLocation()
  const page = location.pathname.split("/").pop()
  const showSynchroniseMarker = hasSyncAttention(template)
  const syncIndicator = getSyncIndicator(template)

  if (template) {
    const unarchive = async () => {
      enqueueSnackbar({ message: 'un-archiving template', variant: 'light' })
      await unarchiveTemplate({ apiSource, apiKey, templateId: template.template_id })
      // TODO handler error
      enqueueSnackbar({ message: 'template un-archived', variant: 'success' })
      refreshTemplates(template.template_id)
      navigate("/templates/" + template.template_id)
    }


    if (template.archived) return (
      <div className='flex flex-row justify-end whitespace-nowrap'>
        <Button onClick={unarchive} variant='text'>Un-archive</Button>
      </div>
    )


    return (
      <>
        <div className='flex flex-row justify-end whitespace-nowrap'>
          <ButtonGroup variant="text" aria-label="Actions">
            <Button onClick={() => navigate("../details")} sx={{ color: page === "details" ? "link" : "text.secondary" }}>Details</Button>
            <Button onClick={() => navigate("../edit")} sx={{ color: page === "edit" ? "link" : "text.secondary" }}>Edit</Button>
            <Button onClick={() => navigate("../duplicate")} sx={{ color: page === "duplicate" ? "link" : "text.secondary" }}>Duplicate</Button>
            <Button onClick={() => navigate("../issue-passes")} sx={{ color: page === "issue-passes" ? "link" : "text.secondary" }}>Create Passes</Button>
            <Button onClick={() => navigate("../passes")} sx={{ color: page === "passes" ? "link" : "text.secondary" }}>View Passes</Button>
            <Button onClick={() => navigate("../stats")} sx={{ color: page === "stats" ? "link" : "text.secondary" }}>Stats</Button>
            {template.managed_pass_template && 
              <Button onClick={() => navigate("../scan-reports")} sx={{ color: page === "can-reports" ? "link" : "text.secondary" }}>Scan Reports</Button>
            }            
            <Button onClick={() => setNotifyOpen(true)} sx={{ color: "text.secondary" }}>Notify All</Button>
            <Button onClick={() => setSyncOpen(true)} sx={{ color: "text.secondary", overflow: "visible" }}>
              <Box sx={{ position: "relative", display: "inline-block", lineHeight: 1.2 }}>
                {showSynchroniseMarker && syncIndicator &&
                  <Box
                    sx={{
                      position: "absolute",
                      left: "50%",
                      top: "-1.45em",
                      transform: "translateX(-50%)",
                      pointerEvents: "none",
                      whiteSpace: "nowrap",
                      borderRadius: "999px",
                      px: 1,
                      py: 0.15,
                      fontSize: 11,
                      fontWeight: 700,
                      backgroundColor:
                        syncIndicator.tone === 'warning'
                          ? 'warning.main'
                          : syncIndicator.tone === 'info'
                            ? 'info.main'
                            : 'success.main',
                      color: syncIndicator.tone === 'warning' ? 'warning.contrastText' : 'common.white',
                      boxShadow: 2,
                    }}
                  >
                    {syncIndicator.label}
                  </Box>
                }
                <span>Synchronise</span>
              </Box>
            </Button>
            <Button onClick={() => setArchiveOpen(true)} sx={{ color: "text.secondary" }}>Archive</Button>
          </ButtonGroup>
        </div>

        <ArchiveDialog open={archiveOpen} setOpen={setArchiveOpen} template={template} processing={processing} setProcessing={setProcessing} />
        <SynchroniseDialog open={syncOpen} setOpen={setSyncOpen} template={template} processing={processing} setProcessing={setProcessing} />
        <NotifyAllDialog open={notifyOpen} setOpen={setNotifyOpen} template={template} processing={processing} setProcessing={setProcessing} />
      </>
    )
  }
}

export default Menu
